const apiHeaders = {};
apiHeaders['Api-Key'] = process.env.REACT_APP_API_KEY;
apiHeaders['cache-control'] = 'no-cache';
export default apiHeaders;